<template>
	<div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="Filtros">
                <div class="col-auto" v-if="ShowVendedores">
                    <label for="Ejecutivos" class="col-form-label text-primary">Vendedor:</label>
                </div>
                <div class="col-auto" v-if="ShowVendedores">
                    <select @change="Lista()" class="form-select form-control-search" name="Ejecutivos" id="Ejecutivos" v-model="Filtro.IdVendedor">
                        <option value=''>Todos</option>
                        <option v-for="(item, idx) in ListaEjecutivos" :value="item.IdUsuario" :key="idx">{{ item.Nombre }}</option>
                    </select>
                </div>
                <div class="col-auto">
                    <label for="Fecha" class="col-form-label text-primary">Fecha:</label>
                </div>
                <div class="col-auto">
                    <Datepicker @input="Lista" v-model="FechaIni" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="Fecha Inicial"></Datepicker>
                </div>

                <div class="col-auto">
                    <Datepicker @input="Lista" v-model="FechaFin" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="Fecha Final"></Datepicker>
                </div>
            </template>
			<template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Nombres</th>
                <th :class="StyleTh">Fecha de Registro</th>
                <th :class="StyleTh">RFC</th>
                <th :class="StyleTh">Telefono</th>
                <th :class="StyleTh">Email</th>
                <th :class="StyleTh">Tipo</th>
                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index" >
					<td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><h6 :class="StylePr">{{lista.Nombres}}</h6></td>
                    <td><p :class="StyleTd">{{lista.FechaReg}}</p></td>
                    <td><p :class="StyleTd">{{lista.RFC}}</p></td>
                    <td><p :class="StyleTd">{{lista.Telefono}}</p></td>
                    <td><p :class="StyleTd">{{lista.Email}}</p></td>
                    <td><p :class="StyleTd">{{lista.Tipo}}</p></td>
                    
					<td class="align-middle text-end">
						<CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="false" :pIsModal="false" :pId="lista.IdCliente" :pEmitSeccion="ConfigList.EmitSeccion" :pGoRoute="ConfigList.GoRoute" :segurity="segurity">
							<template slot="btnaccion">
                                
                                <CMoreButtons>
							        <template slot="bodyBtns">
                                        <li class="btnIcons mx-1">
                                            <button type="button" @click="EvniarCorreo(lista)" class="btn_icon" v-b-tooltip.hover.Top title="Correo de Bienvenida">
                                                <i class="fas fa-envelope-open-text"></i>
                                            </button>
                                        </li>

                                        <template v-if="segurity.DiscardClient">
                                            <li class="btnIcons mx-1">
                                                <button type="button" @click="Descarte(lista)" class="btn_icon" v-b-tooltip.hover.Top title="Descartar Cliente">
                                                    <i class="fas fa-user-slash"></i>
                                                </button>
                                            </li>
                                        </template>

                                        <li class="btnIcons mx-1">
                                            <button type="button" @click="IrASeguimientoAcciones(lista.IdCliente)" class="btn_icon" v-b-tooltip.hover.Top title="SeguimientoAcciones">
                                                <i class="fas fa-map-marker-check"></i>
                                            </button>
                                        </li>
                                        
                                        <template v-if="segurity.ViewLogs">
                                            <li class="btnIcons mx-1">
                                                <button type="button" @click="IrABitacoras(lista)" class="btn_icon" v-b-tooltip.hover.Top title="Ver Bitácora">
                                                    <i class="fas fa-book"></i>
                                                </button>
                                            </li>
                                        </template>

                                        <template v-if="segurity.ViewSurveys">
                                            <li class="btnIcons">
                                                <button type="button" @click="IraEncuesta(lista)" class="btn_icon" v-b-tooltip.hover.Top title="Ver Encuestas">
                                                    <i class="fas fa-clipboard-list-check"></i>
                                                </button>
                                            </li>
                                        </template>

                                        <template v-if="segurity.ViewAgenda">
                                            <li class="btnIcons mx-1">
                                                <button type="button" @click="IraAgenda(lista)" class="btn_icon" v-b-tooltip.hover.Top title="Agenda">
                                                    <i class="fas fa-address-book"></i>
                                                </button>
                                            </li>
                                        </template>

                                        <template v-if="segurity.AssignPersonnel">
                                            <li class="btnIcons mx-1">
                                                <button type="button" @click="AsignarPersonal(lista)" class="btn_icon" v-b-tooltip.hover.Top title="Asignar Personal">
                                                    <i class="fas fa-user-check"></i>
                                                </button>
                                            </li>
                                        </template>

                                        <template v-if="segurity.ViewQuotations">
                                            <li class="btnIcons mx-1">
                                                <button type="button" @click="IraCotizaciones(lista)" class="btn_icon" v-b-tooltip.hover.Top title="Cotizaciones">
                                                    <i class="fas fa-file-invoice-dollar"></i>
                                                </button>
                                            </li>
                                        </template>
                                    </template>
                                </CMoreButtons>
                                        
                            </template>
						</CBtnAccion>     
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="8"></CSinRegistros>
			</template>
		</CList>

		<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave"></Form>
			</template>
		</CModal>

        <CModal :pConfigModal="ConfigModal2" :poBtnSave="oBtnSave2">
            <template slot="Form">
                <FormPersonal :poBtnSave="oBtnSave2"></FormPersonal>
            </template>
        </CModal>

        <CModal :pConfigModal="ConfigModal3" :poBtnSave="oBtnSave3">
            <template slot="Form">
                <FormDescarte :poBtnSave="oBtnSave3"></FormDescarte>
            </template>
        </CModal>
	</div>
</template>

<script>

import moment from 'moment';
import Form from '@/views/modulos/crm/cliente/FormProspecto.vue';
import FormCliente from '@/views/modulos/crm/cliente/Form.vue';
import FormPersonal from '@/views/modulos/crm/cliente/FormPersonal.vue';
import FormDescarte from '@/views/modulos/crm/cliente/FormDescarte.vue';
import Calendar from '@/helpers/StaticComboBox.js';

import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionCliente';
const EmitEjecuta2 = 'seccionPersonal2';
const EmitEjecuta3 = 'seccionDescarte';

export default {
    name: 'ListaCliente',
    props: ['sFiltros','pOrigen'],
    components: {
        Form,
        FormCliente,
        FormPersonal,
        FormDescarte,
    },
    data() {
        return {
            ConfigList:{
                Title: 'Prospectos',
                IsModal: true,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: '',
                GoRoute: 'clientesform',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                IdVendedor:'',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal:{
                ModalTitle: "Prospecto",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ModalSize: 'lg',
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            ConfigModal2:{
                ModalTitle: "Eventos Por Personal",
                ModalNameId: 'ModalForm2',
                EmitSeccion: EmitEjecuta2,
                ModalSize: 'xl',
				ShowFooter: false,
            },
            oBtnSave2: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
            },
            ConfigModal3:{
                ModalTitle: "Descartar Evento",
                ModalNameId: 'ModalForm3',
                EmitSeccion: EmitEjecuta3,
                ModalSize: 'lg',
            },
            oBtnSave3: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta3,
            },
            FechaIni:'',
            FechaFin:'',
            segurity: {},
            obj: {},
            ListaEjecutivos:[],
            ShowVendedores:false,
            ListaArrayRows: [],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            Setpicker: Calendar.calendarSettings,
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;
            let fechaIni = this.FechaIni ? moment(this.FechaIni).format('YYYY-MM-DD') : '';
            let fechaFin = this.FechaFin ? moment(this.FechaFin).format('YYYY-MM-DD') : '';
            await this.$http.get("clientes",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdVendedor:this.Filtro.IdVendedor,
                    FechaIni: fechaIni,
                    FechaFin: fechaFin,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
                let filter              = res.data.filter
                if(!this.segurity.ViewMyProspects || filter){
                    this.ShowVendedores = true;
                }
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('clientes/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar() {
            this.$router.push({name:'panelSubMenus',params:{}});
        },
        IraCotizaciones(item){
            this.$router.push({name:'cotizacion',params:{objEnviado: item}});
        },
        IraAgenda(item){
            this.$router.push({name:'agenda',params:{objEnviado: item}});
        },
        IraEncuesta(item){
            this.$router.push({name:'enviarEncuesta',params:{objEnviado:item}});
        },
        AsignarPersonal(item)
		{
			this.bus.$emit('NewModal_'+EmitEjecuta2,item);
		},
        IrABitacoras(item){
            this.$router.push({name:'bitacora',params:{objEnviado:item}});
        },
        Descarte(item)
		{
            this.bus.$emit('NewModal_'+EmitEjecuta3,item);
		},
        IrASeguimientoAcciones(id){
            this.$router.push({name:'seguimientoacciones',params:{pIdCliente:id}});
        },
        GetComboEjecutivos()
        {
            this.$http.get('users',{
                params:{
                    simple:true,
                    TipoUsuario:'US'
                }
            }).then((res)=> {
                this.ListaEjecutivos = res.data.data;
            }).catch(err => console.error(err))
        },
        EvniarCorreo(item)
        {
            this.$swal(
            {
                title: '<h2 style="font-size:25px; font-weight: 700;">¿Desea enviar mensaje de bienvenida?</h2>',
                text: '',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar',
                showCloseButton: true,
                showLoaderOnConfirm: true,
                confirmButtonColor: '#0096ED',
                cancelButtonColor: '#b92e27',
            }).then((result) =>
            {
                if(result.value)
                {
                    this.ConfigList.ShowLoader = true;
                    this.$http.get('enviarCorreoBienvenida',{
                        params:{
                            IdCliente: item.IdCliente
                        }
                    }).then((res)=> {
                        this.$toast.success('Correo Enviado');
                    }).catch(err => {
                        this.$toast.warning(err.message);
                    }).finally(()=>{
                        this.ConfigList.ShowLoader = false;
                    });
                }
            });
        },
    },
    created()
    {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }
        
        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.GetComboEjecutivos();
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
